const css = `.post-editor-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.post-editor-header .draft-tag.p-tag-warning {
  border-color: var(--warning);
  padding: 4px;
}
.post-editor-header .draft-tag.p-tag-warning .p-tag-value {
  font-size: var(--font-size-sm);
  line-height: var(--line-height-none);
}

.post-editor .post-image {
  margin: 16px auto;
  height: 300px;
  display: flex;
}
.post-editor .post-image img {
  max-height: 300px;
  width: 100%;
}
.post-editor .post-image-placeholder {
  width: min(100%, 480px);
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--space-2);
  background-color: var(--surface-sunken);
  border: 1px dashed var(--border-strong);
  border-radius: var(--radius-lg);
  color: var(--text-muted);
  font-size: var(--font-size-sm);
}
.post-editor .post-image-placeholder i {
  font-size: var(--font-size-4xl);
}
.post-editor .post-editor-buttons {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  row-gap: 8px;
  justify-content: end;
  margin-top: 8px;
}
.post-editor .post-editor-buttons button[type=submit] {
  margin-left: 8px;
}
.post-editor .post-editor-buttons .delete-post-button {
  margin-right: auto;
}

.editor-error-fallback {
  padding: 24px;
  border: 1px solid var(--border);
  border-radius: 4px;
  background-color: var(--surface-sunken);
  text-align: center;
  color: var(--text-muted);
  min-height: 200px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};
